import { useParams } from 'react-router-dom';
import { useFile } from '@/hooks/prompts';
import EntityBreadcrumb from '../EntityBreadcrumb';
import { FileCrumbProps } from './types';

const FileCrumb = ({ promptParam, fileParam, isCurrentPage = false }: FileCrumbProps) => {
    const params = useParams();
    const promptId = params[promptParam];
    const fileId = params[fileParam];

    const { data: file, isLoading } = useFile({
        promptId: promptId || '',
        fileId: fileId || '',
    });

    const label = isLoading ? '...' : file?.name || `File ${fileId?.slice(0, 8)}...`;

    return (
        <EntityBreadcrumb
            label={label}
            entityId={fileId || ''}
            entityType="File"
            isCurrentPage={isCurrentPage}
            isLoading={isLoading}
        />
    );
};

export default FileCrumb;
